export default __webpack_public_path__ + "static/media/loader_3d_matic.095142f6.gif";